export enum SegmentedControlType {
  SOLID = 'SOLID',
  SOLID_COLOR = 'SOLID_COLOR',
  SOLID_HIGHLIGHT = 'SOLID_HIGHLIGHT'
}
